// extracted by mini-css-extract-plugin
export var filterIncDec = "_el-0";
export var leftBorder = "_el-1";
export var rightBorder = "_el-2";
export var stringInput = "_el-3";